import store from '@/store';
import { isMobileLayout } from '@/utils/mobile-detection';

const isMobileView = () => isMobileLayout() || store.getters['CommonStore/isMobileApp'];

// Pulse home is desktop-only. On mobile, keep the original dashboard home instead of Pulse.
// (The dashboard route only bounces back to /home on desktop, so this can't loop.)
// The one exception is a recommendation deep link: a BizAI notification points at
// `/home?recommendation=<uid>` (README, "Recommendation deep link from email/SMS"), and on
// mobile the feed that reads it is `/pulse`. Sending it to the dashboard would drop the uid.
const redirectToDashboardOnMobile = (to, from, next) => {
  if (!isMobileView()) {
    next();
  } else if (to.query?.recommendation) {
    next({ name: 'pulse', query: to.query });
  } else {
    next({ name: 'dashboard' });
  }
};

// Mirror of the above: `/pulse` is mobile-only, so desktop goes to `/home`, where Pulse
// already lives. The guards are opposites, so neither can loop.
const redirectToHomeOnDesktop = (to, from, next) => {
  if (isMobileView()) {
    next();
  } else if (to.query?.recommendation) {
    next({ name: 'home', query: to.query });
  } else {
    next({ name: 'home' });
  }
};

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "PulseFeed" */ './views/HomeView.vue'),
    meta: { i18n: 'pulse-pov', pageNameEn: 'Home' },
    beforeEnter: redirectToDashboardOnMobile,
  },
  // Where the mobile bottom-nav Pulse tab (and a Pulse deep link) lands. `/home` stays the
  // dashboard on mobile — VCITA2-15112 — so the feed needs an address of its own.
  {
    path: '/pulse',
    name: 'pulse',
    component: () => import(/* webpackChunkName: "PulseMobile" */ './views/PulseMobilePage.vue'),
    meta: { i18n: 'pulse-pov', pageNameEn: 'Pulse' },
    beforeEnter: redirectToHomeOnDesktop,
  },
];

export default routes;
